import React from 'react';
import classNames from 'classnames';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';

const SliderHandle = ({
  onMouseDown,
  onSliderMove,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onKeyDown,
  isFocused,
  setRef
}) => {
  return (
    <button
      ref={setRef}
      className={classNames(
        'slider__handle',
        'comet-button',
        'comet-button--primary',
        'comet-button--icon-only',
        {
          'slider__handle--grabbing': isFocused
        }
      )}
      onMouseDown={onMouseDown}
      onKeyDown={onKeyDown}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <svg
        className="comet-button__icon comet-button__icon--left slider__handle--icon"
        aria-hidden="true"
        focusable="false"
      >
        <use xlinkHref={`${icons}#expand`} />
      </svg>
      <span className="comet-screenreader-only">Drag</span>
    </button>
  );
};

export default SliderHandle;



// WEBPACK FOOTER //
// ../core/src/components/Slider/SliderHandle.js